export default __webpack_public_path__ + "8daa962.png";